const WarningIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <circle cx="8" cy="8" r="7" stroke="#777" strokeWidth="1.2" />
    <path
      d="M8 4.75V8.25M8 10.75H8.005"
      stroke="#777"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

export default WarningIcon;